// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const hoppip: PokeData = {
  "id": 187,
  "name": "hoppip",
  "height": 4,
  "weight": 5,
  "base_experience": 50,
  "types": [
    PokeType.GRASS,
    PokeType.FLYING
  ],
  "api_moves": [
    "tackle",
    "tail-whip",
    "absorb",
    "mega-drain",
    "leech-seed",
    "poison-powder",
    "stun-spore",
    "sleep-powder",
    "splash",
    "cotton-spore",
    "giga-drain",
    "synthesis",
    "memento",
    "bullet-seed",
    "bounce",
    "u-turn",
    "worry-seed",
    "rage-powder",
    "acrobatics",
    "fairy-wind"
  ],
  "moves": [
    "tackle",
    "poison-powder",
    "stun-spore",
    "splash",
    "synthesis",
    "bullet-seed",
    "acrobatics",
    "energy-ball",
    "aromatherapy",
    "gust",
    "wood-hammer",
    "grassy-terrain",
    "air-slash"
  ],
  "evolution_chain": {
    "id": 92,
    "item": null,
    "species": [
      {
        "name": "hoppip",
        "order": 216,
        "types": [
          PokeType.GRASS,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "skiploom",
        "order": 217,
        "types": [
          PokeType.GRASS,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 187,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "jumpluff",
        "order": 218,
        "types": [
          PokeType.GRASS,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 188,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 27,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 41.25,
    "speed": 50,
    "ability_power": 35
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
